let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ftRLE")).then(() => parcelRequire('8wK7s'));